import DOMPurify from 'dompurify';

export const Utills = {
  calculateDateDifferenceInDays: (startDate: any, endDate: any) => {
    const MS_PER_DAY = 24 * 60 * 60 * 1000;
    const start = new Date(startDate).setHours(0, 0, 0, 0);
    const end = new Date(endDate).setHours(0, 0, 0, 0);
    const differenceInMS = end - start;
    const differenceInDays = differenceInMS / MS_PER_DAY;
    return differenceInDays;
  },
  //Console.log Utility
  cl: (messages: any, ...params: any[]) => {
    if (process.env.REACT_APP_SHOW_CONSOLE_LOG === 'yes') {
    }
  },
  //Console.error Utility
  cle: (messages: any, ...params: any[]) => {
    console.error(messages, ...params);
  },
  usNumberFormat: ({ cell }: { cell: any }) => {
    const weightUsed = cell.getValue() as string;
    if (!isNaN(parseFloat(weightUsed)) && isFinite(Number(weightUsed))) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(weightUsed));
    }
    return weightUsed
  },
  sanitizeInput: (input: any): any => {
    if (typeof input === 'string') {
      return DOMPurify.sanitize(input);
    } else if (Array.isArray(input)) {
      return input.map((item) => Utills.sanitizeInput(item));
    } else if (typeof input === 'object' && input !== null) {
      return Object.fromEntries(
        Object.entries(input).map(([key, value]) => [key, Utills.sanitizeInput(value)])
      );
    }
    return input;
  },
  restrictNA:(value:string)=> {
        if (!value) return true; // Let required handle empty values
        const trimmedValue = value.trim().toLowerCase();
        const invalidValues = ["na", "n/a", "na.", "na ", "not available", "null", "nil", "none", "n a", "n.a", "n / a"];
        if (invalidValues.includes(trimmedValue)) {
          return false;
        }
        return true;
      }
}